import { LoquixActionButton } from './loquix-action-button.js';

if (!customElements.get('loquix-action-button')) {
  customElements.define('loquix-action-button', LoquixActionButton);
}
